import { IconCircle } from 'foundations-components/transitional/components/IconCircle';
import { NextIcon } from 'foundations-assets';
import { View } from 'foundations-components/components/View';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const ListItemWithIcon = ({
  children
}) => /*#__PURE__*/_jsxs(View, {
  marginBlockEnd: "300",
  children: [/*#__PURE__*/_jsx(IconCircle, {
    icon: NextIcon,
    color: "fill-accent-purple-pressed",
    size: "100",
    backgroundColor: "fill-accent-purple-subtle",
    borderColor: "fill-accent-purple-subtle",
    padding: "100",
    marginInlineEnd: "200"
  }), children]
});
export default ListItemWithIcon;